module.exports = __webpack_public_path__ + "static/media/mapLegend.cb6daad6.svg";